module.exports = __webpack_public_path__ + "img/feather-icons/warning-triangle.d050a38.svg";